import React, { useEffect } from 'react';
import { useProductContext } from '../../../extensible/product-router';
import { onShown } from '../events';
import { withAnalytics } from '../with-analytics';
export const DialogShownHandlerComponent = ({
  isExpanded,
  onDialogShown
}) => {
  const {
    products
  } = useProductContext();
  useEffect(() => {
    const emitAnalyticsEvent = () => {
      const visibleProducts = products.map(product => product.title);
      const visibleTabsCount = visibleProducts.length > 1 ? products.length : 0;
      onDialogShown({
        visibleProducts,
        visibleTabsCount
      });
    };
    isExpanded && emitAnalyticsEvent();
  }, [isExpanded]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export const DialogShownHandler = withAnalytics({
  onDialogShown: onShown
})(DialogShownHandlerComponent);